
import { Component, Prop, Vue } from "vue-property-decorator";
import { Addressable } from "@/survey";

@Component({})
export default class AddressDisplay extends Vue {
  @Prop() address!: Addressable;
}
